import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { AlertCardComponent } from '@shared/components/alert-card/alert-card.component';
import { LookupItemStruct } from '@shared/services/structs/motor-fiscal/lookup-item.struct';

@Component({
  selector: 'app-importar-xml-natureza-step',
  standalone: true,
  imports: [CommonModule, FormsModule, MatFormFieldModule, MatIconModule, MatSelectModule, AlertCardComponent],
  templateUrl: './importar-xml-natureza-step.component.html',
  styleUrls: ['./importar-xml-natureza-step.component.css'],
})
export class ImportarXmlNaturezaStepComponent {
  @Input() descricaoNaturezaOperacaoXml: string | null = null;
  @Input() listaNaturezaOperacao: LookupItemStruct[] = [];
  @Input() idNaturezaOperacaoSistema: number | null = null;
  @Output() idNaturezaOperacaoSistemaChange = new EventEmitter<number | null>();

  onNaturezaChange(valor: number | null): void {
    this.idNaturezaOperacaoSistema = valor;
    this.idNaturezaOperacaoSistemaChange.emit(valor);
  }
}
